// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1reAi","rootMobile":"styles_rootMobile__zx1M_"};